import {
  MinusIconWrapper,
  OutsideIconWrapper,
  ProcessCardWrapper,
} from "./styles";
import { useTranslation } from "next-i18next";
import { Block, Box } from "../../../styles/basicStyles";
import { colors } from "../../../styles/colors";
import { FC } from "react";
import Typography from "../../../components/typography";
import Icon from "../../../components/icon";

interface ProcessCardProps {
  index: number;
  title: string;
  description: string;
  outcomesWithSubtitle?: string;
  outcomes: string[];
  arrows?: boolean;
  onView: boolean;
}

const ProcessCard: FC<ProcessCardProps> = ({
  index,
  title,
  description,
  outcomes,
  outcomesWithSubtitle,
  arrows = true,
  onView,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      fDirection="row"
      fAlign="center"
      w="100%"
      ml={{ md: arrows && index % 2 === 0 ? 1.063 : 0 }}
      mr={{ md: arrows && index % 2 !== 0 ? 1.063 : 0 }}
    >
      {arrows && index % 2 === 0 && (
        <OutsideIconWrapper>
          <Icon
            icon="outlined_cardArrowRight"
            color={onView ? colors.blackCow : colors.darkJungleGreen}
          />
        </OutsideIconWrapper>
      )}
      <ProcessCardWrapper
        onView={onView}
        padding={{ md: "1.875rem 2rem", xxs: "1.5rem 0.813rem" }}
      >
        <Box fWrap="wrap">
          <Block display="flex" fDirection="row" mr={1.25}>
            <Typography
              fSize={{ md: 1.875, xxs: 1.625 }}
              lHeight={{ md: 2.25, xxs: 1.938 }}
              fWeight={700}
              color={colors.white}
            >
              0{index}
            </Typography>
            <Block ml={0.3}>
              <Icon
                icon="outlined_diagonalLine"
                color={colors.purple}
                size={[2.25, 0.9]}
              />
            </Block>
          </Block>
          <Typography
            as='h3'
            fSize={{ md: 1.875, xxs: 1.625 }}
            lHeight={{ md: 2.25, xxs: 1.938 }}
            fWeight={700}
            color={colors.white}
          >
            {title}
          </Typography>
        </Box>
        <Box mt={1.25}>
          <Typography
            fSize={{ md: 1.125, xxs: 1 }}
            lHeight={1.688}
            fWeight={350}
            color={colors.white}
            opacity={0.8}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </Box>
        <Block
          h={0.125}
          w="100%"
          bgColor={colors.white}
          opacity={0.3}
          mt={{ md: 1.5, xxs: 1 }}
          mb={{ md: 1.5, xxs: 1 }}
        />
        <Box fAlign="center" mb={{ md: 1.063, xxs: 0.5 }}>
          <Typography
            fSize={{ md: 1.375, xxs: 1.25 }}
            lHeight={1.688}
            fWeight={600}
            color={colors.white}
          >
            {t("OUTCOMES")}
          </Typography>
          {outcomesWithSubtitle && (
            <Typography
              fSize={{ md: 1, xxs: 0.75 }}
              lHeight={{ md: 1.688, xxs: 0.875 }}
              fWeight={350}
              color={colors.white}
              ml={{ md: 0.688, xxs: 0.563 }}
              opacity={0.65}
            >
              {t(outcomesWithSubtitle)}
            </Typography>
          )}
        </Box>
        <Box fWrap="wrap" w="unset">
          {outcomes.map((e, index) => (
            <Block key={index} mr={1.375}>
              <Typography
                fSize={{ md: 1.125, xxs: 1 }}
                lHeight={{ md: 1.375, xxs: 1.188 }}
                fWeight={350}
                color={colors.white}
              >
                <MinusIconWrapper>
                  <Block h={0.188} w={0.938} bgColor={colors.lightBlue} />
                </MinusIconWrapper>
                {t(e)}
              </Typography>
            </Block>
          ))}
        </Box>
      </ProcessCardWrapper>
      {arrows && index % 2 !== 0 && (
        <Icon
          icon="outlined_cardArrowRight"
          color={onView ? colors.blackCow : colors.darkJungleGreen}
        />
      )}
    </Box>
  );
};

export default ProcessCard;
